import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

const groupByMap = {
  0: "Agent",
  1: "Office",
  2: "Player",
};

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WebVsPhoneStats() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />

        <div>
          <SubGroup title="Group By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Agent"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Office"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Web vs Phone Stats Report"
        getUrl={() => "/Reports/Report_WebvsPhoneStats"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          Office: office,
          Distributor: distributor,
          AgentTo: agentTo,
          AgentFrom: agentFrom,
          GroupBy: groupBy,
        })}
        getTotals={(data) => ({
          strID: "Total",
          phoneVol: data.reduce((acc, item) => acc + item.phoneVol, 0),
          phoneCount: data.reduce((acc, item) => acc + item.phoneCount, 0),
          phonePlayersCount: data.reduce(
            (acc, item) => acc + item.phonePlayersCount,
            0
          ),
          onlineVol: data.reduce((acc, item) => acc + item.onlineVol, 0),
          onlineCount: data.reduce((acc, item) => acc + item.onlineCount, 0),
          onlinePlayersCount: data.reduce(
            (acc, item) => acc + item.onlinePlayersCount,
            0
          ),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="strID">
          {groupByMap[groupBy]}
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneVol">
          Phone Volume
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneCount">
          Phone Bets
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phonePlayersCount">
          Phone Players
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="onlineVol">
          Online Volume
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="onlineCount">
          Online Bets
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="onlinePlayersCount">
          Online Players
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default WebVsPhoneStats;
